var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/components/subscription-button.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { followAccount, subscribeAccount, unsubscribeAccount } from 'soapbox/actions/accounts';
import snackbar from 'soapbox/actions/snackbar';
import { IconButton } from 'soapbox/components/ui';
import { useAppDispatch, useFeatures } from 'soapbox/hooks';
const messages = defineMessages({
  subscribe: {
    "id": "account.subscribe",
    "defaultMessage": "Subscribe to notifications from @{name}"
  },
  unsubscribe: {
    "id": "account.unsubscribe",
    "defaultMessage": "Unsubscribe to notifications from @{name}"
  },
  subscribeSuccess: {
    "id": "account.subscribe.success",
    "defaultMessage": "You have subscribed to this account."
  },
  unsubscribeSuccess: {
    "id": "account.unsubscribe.success",
    "defaultMessage": "You have unsubscribed from this account."
  },
  subscribeFailure: {
    "id": "account.subscribe.failure",
    "defaultMessage": "An error occurred trying to subscribe to this account."
  },
  unsubscribeFailure: {
    "id": "account.unsubscribe.failure",
    "defaultMessage": "An error occurred trying to unsubscribe to this account."
  }
});

const SubscriptionButton = _ref => {
  var _account$relationship, _account$relationship2, _account$relationship3, _account$relationship4;

  let {
    account
  } = _ref;
  const dispatch = useAppDispatch();
  const features = useFeatures();
  const intl = useIntl();
  const isFollowing = (_account$relationship = account.relationship) === null || _account$relationship === void 0 ? void 0 : _account$relationship.following;
  const isRequested = (_account$relationship2 = account.relationship) === null || _account$relationship2 === void 0 ? void 0 : _account$relationship2.requested;
  const isSubscribed = features.accountNotifies ? (_account$relationship3 = account.relationship) === null || _account$relationship3 === void 0 ? void 0 : _account$relationship3.notifying : (_account$relationship4 = account.relationship) === null || _account$relationship4 === void 0 ? void 0 : _account$relationship4.subscribing;
  const title = isSubscribed ? intl.formatMessage(messages.unsubscribe, {
    name: account.get('username')
  }) : intl.formatMessage(messages.subscribe, {
    name: account.get('username')
  });

  const onSubscribeSuccess = () => dispatch(snackbar.success(intl.formatMessage(messages.subscribeSuccess)));

  const onSubscribeFailure = () => dispatch(snackbar.error(intl.formatMessage(messages.subscribeFailure)));

  const onUnsubscribeSuccess = () => dispatch(snackbar.success(intl.formatMessage(messages.unsubscribeSuccess)));

  const onUnsubscribeFailure = () => dispatch(snackbar.error(intl.formatMessage(messages.unsubscribeFailure)));

  const onNotifyToggle = () => {
    var _account$relationship5;

    if ((_account$relationship5 = account.relationship) !== null && _account$relationship5 !== void 0 && _account$relationship5.notifying) {
      var _dispatch;

      (_dispatch = dispatch(followAccount(account.get('id'), {
        notify: false
      }))) === null || _dispatch === void 0 ? void 0 : _dispatch.then(() => onUnsubscribeSuccess()).catch(() => onUnsubscribeFailure());
    } else {
      var _dispatch2;

      (_dispatch2 = dispatch(followAccount(account.get('id'), {
        notify: true
      }))) === null || _dispatch2 === void 0 ? void 0 : _dispatch2.then(() => onSubscribeSuccess()).catch(() => onSubscribeFailure());
    }
  };

  const onSubscriptionToggle = () => {
    var _account$relationship6;

    if ((_account$relationship6 = account.relationship) !== null && _account$relationship6 !== void 0 && _account$relationship6.subscribing) {
      var _dispatch3;

      (_dispatch3 = dispatch(unsubscribeAccount(account.get('id')))) === null || _dispatch3 === void 0 ? void 0 : _dispatch3.then(() => onUnsubscribeSuccess()).catch(() => onUnsubscribeFailure());
    } else {
      var _dispatch4;

      (_dispatch4 = dispatch(subscribeAccount(account.get('id')))) === null || _dispatch4 === void 0 ? void 0 : _dispatch4.then(() => onSubscribeSuccess()).catch(() => onSubscribeFailure());
    }
  };

  const handleToggle = () => {
    if (features.accountNotifies) {
      onNotifyToggle();
    } else {
      onSubscriptionToggle();
    }
  };

  if (!features.accountSubscriptions && !features.accountNotifies) {
    return null;
  }

  if (isRequested || isFollowing) {
    return /*#__PURE__*/React.createElement(IconButton, {
      src: isSubscribed ? require('@tabler/icons/bell-ringing.svg') : require('@tabler/icons/bell.svg'),
      onClick: handleToggle,
      title: title,
      theme: "outlined",
      className: "px-2",
      iconClassName: "w-4 h-4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 92,
        columnNumber: 7
      }
    });
  }

  return null;
};

export default SubscriptionButton;